'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./link.scss');

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Link(_ref) {
  var decoration = _ref.decoration,
      disabled = _ref.disabled,
      href = _ref.href,
      className = _ref.className,
      onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, ['decoration', 'disabled', 'href', 'className', 'onClick']);

  var classes = (0, _classnames2.default)('link', decoration && 'link--decoration-' + decoration, disabled && 'link--disabled', className);

  return _react2.default.createElement(
    'a',
    _extends({
      href: href,
      className: classes,
      onClick: disabled ? null : onClick
    }, props),
    props.children
  );
}

Link.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  className: _propTypes2.default.string,
  decoration: _propTypes2.default.oneOf(['dotted']),
  disabled: _propTypes2.default.bool,
  href: _propTypes2.default.string,
  onClick: _propTypes2.default.func
};

exports.default = Link;